import React from 'react';
import PropTypes from 'prop-types';

import { Link } from 'react-router-dom';

import { Card as NacreCard, HeaderCard, ContentCard, TitleCard, SubTitleCard, DropdownCard, DropdownItem } from '@weezevent/nacre';

function CardCTA({ to = '', label = '', onClick = () => {} }) {
    return (
        <Link className="wz-ticket-card-cta floated" to={to} onClick={onClick}>
            {label}
        </Link>
    );
}

CardCTA.propTypes = {
    to: PropTypes.string,
    label: PropTypes.string,
    onClick: PropTypes.func
};

function CardDropDown({ items = [] }) {
    return (
        <DropdownCard>
            {items.map((item, i) => (
                <DropdownItem key={i} item={item.label} onClick={item.onClick} />
            ))}
        </DropdownCard>
    );
}

CardDropDown.propTypes = {
    items: PropTypes.array
};

export function Card({
    className = '',
    headerClassName = '',
    titleClassName = '',
    contentClassName = '',
    title = null,
    subtitle = null,
    children = null,
    dropdown = null,
    cta = null,
    header = null,
    separator = true
}) {
    return (
        <NacreCard className={className}>
            {title && (
                <HeaderCard separator={separator} className={headerClassName}>
                    {header}
                    <TitleCard title={title} className={titleClassName} />
                    {cta && <CardCTA to={cta.to} onClick={cta.onClick} label={cta.label} />}
                    {subtitle && <SubTitleCard title={subtitle} />}
                    {dropdown && <CardDropDown items={dropdown} />}
                </HeaderCard>
            )}
            <ContentCard className={contentClassName}>{children}</ContentCard>
        </NacreCard>
    );
}

Card.propTypes = {
    className: PropTypes.string,
    headerClassName: PropTypes.string,
    titleClassName: PropTypes.string,
    contentClassName: PropTypes.string,
    header: PropTypes.node,
    title: PropTypes.string,
    subtitle: PropTypes.string,
    children: PropTypes.node,
    dropdown: PropTypes.array,
    cta: PropTypes.object
};
